export const cantSemanasInstitucion = {
  0: [...Array(16).keys()].map((i) => i + 1),
  270: [...Array(35).keys()].map((i) => i + 1),
};
